import React from 'react'
import { useNavigate } from 'react-router-dom'
import { usePaymentStore } from 'stores/paymentStore'
import { SNL_THANK_YOU_PATH } from '../constants'

function PayLaterBlock() {
  const { setPayLater } = usePaymentStore()
  const navigate = useNavigate()
  const handlePayLater = () => {
    setPayLater( true )
    navigate( SNL_THANK_YOU_PATH.concat( window.location.search ) )
  }
  return (
    <div className="flex flex-col gap-4 mt-4 w-full mx-auto items-center">
      <button
        id="pay-now-button"
        className="btn-primary py-3 px-8 rounded-md font-medium"
        onClick={() => setPayLater( false )}
        data-testid="snl-pay-now-button"
      >
        {`Pay Now`}
      </button>
      <button
        id="pay-later-button"
        className="btn-secondary py-3 px-8 rounded-md font-medium"
        onClick={handlePayLater}
        data-testid="snl-pay-later-button"
      >
        {`Place Order & Pay Later`}
      </button>
    </div>
  )
}

export default PayLaterBlock